var pollingInterval = null
var snoozeTimer = null

var PROCESSED_STORAGE_KEY = 'recordingMonitor.processedRecordings'
var PROCESSED_TTL_MS = 24 * 60 * 60 * 1000

function loadProcessedFromStorage () {
  try {
    var raw = window.sessionStorage.getItem(PROCESSED_STORAGE_KEY)
    if (!raw) return {}
    var parsed = JSON.parse(raw)
    var now = Date.now()
    var fresh = {}
    Object.keys(parsed).forEach(function (key) {
      if ((now - parsed[key]) < PROCESSED_TTL_MS) fresh[key] = parsed[key]
    })
    return fresh
  } catch (e) {
    return {}
  }
}

function persistProcessed (map) {
  try {
    window.sessionStorage.setItem(PROCESSED_STORAGE_KEY, JSON.stringify(map))
  } catch (e) {}
}

var state = {
  isPolling: false,
  pendingRecordings: [],
  currentRecording: null,
  isAnalyzing: false,
  snoozedRecording: null,
  processedRecordings: loadProcessedFromStorage()
}

var mutations = {
  setPolling: function (state, val) {
    state.isPolling = val
  },
  setPendingRecordings: function (state, recordings) {
    state.pendingRecordings = recordings
  },
  setCurrentRecording: function (state, recording) {
    state.currentRecording = recording
  },
  clearCurrentRecording: function (state) {
    state.currentRecording = null
  },
  setAnalyzing: function (state, val) {
    state.isAnalyzing = val
  },
  setSnoozedRecording: function (state, recording) {
    state.snoozedRecording = recording
  },
  clearSnoozedRecording: function (state) {
    state.snoozedRecording = null
  },
  markProcessed: function (state, key) {
    if (!key) return
    var now = Date.now()
    var next = {}
    Object.keys(state.processedRecordings).forEach(function (k) {
      if ((now - state.processedRecordings[k]) < PROCESSED_TTL_MS) {
        next[k] = state.processedRecordings[k]
      }
    })
    next[key] = now
    state.processedRecordings = next
    persistProcessed(next)
  }
}

var actions = {
  startPolling: function (context, payload) {
    var commit = context.commit
    var dispatch = context.dispatch
    var vm = payload.vm

    if (pollingInterval) return

    commit('setPolling', true)
    // Initial poll after 10s delay to let app load
    setTimeout(function () {
      dispatch('pollOnce', { vm: vm })
    }, 10000)

    pollingInterval = setInterval(function () {
      dispatch('pollOnce', { vm: vm })
    }, 60000)
  },

  pollOnce: function (context, payload) {
    var commit = context.commit
    var dispatch = context.dispatch
    var state = context.state
    var vm = payload.vm

    // Skip if modal is already open, analysis is running, or recording is snoozed
    if (state.currentRecording || state.isAnalyzing || state.snoozedRecording) return

    var fifteenMinutesMs = 15 * 60 * 1000

    vm.$network_utils.getCallMonitorCalls({
      recruiter: vm.$utils.getOwner().name
    })
      .then(function (response) {
        var calls = response.calls || []
        var now = new Date()

        // Filter: completed + pending analysis + within last 15 minutes + not already processed in this session
        var processed = state.processedRecordings || {}
        var pending = calls.filter(function (call) {
          if (call.status !== 'completed') return false
          if (call.analysis_status !== 'pending') return false
          var modifiedAt = new Date(call.modified_at)
          if ((now - modifiedAt) > fifteenMinutesMs) return false
          if (processed[call.path] || processed[call.filename]) return false
          return true
        })

        commit('setPendingRecordings', pending)

        if (pending.length === 0) return

        // Sort by modified_at descending — take only the most recent call
        pending.sort(function (a, b) {
          return new Date(b.modified_at) - new Date(a.modified_at)
        })

        var call = pending[0]
        var recording = {
          filename: call.filename,
          path: call.path,
          hint_type: call.contact_type,
          hint_value: call.contact
        }
        dispatch('openRecordingModal', { vm: vm, recording: recording })
      })
      .catch(function (err) {
        console.error('[RecordingMonitor] Poll error:', err.message || err)
      })
  },

  openRecordingModal: function (context, payload) {
    var commit = context.commit
    var dispatch = context.dispatch
    var vm = payload.vm
    var recording = payload.recording

    commit('setCurrentRecording', recording)

    // Open blocking modal
    vm.$store.commit('modals/create', {
      designator: 'recording-detected-modal',
      component_name: 'RecordingDetectedModal',
      modal_width: 1100,
      is_center_modal: true,
      modal_title: 'זיהינו שיחה חדשה במערכת',
      is_fixed: true,
      persistent: true,
      show_close_button: false,
      props: {
        recording: recording,
        onComplete: function () {
          commit('clearCurrentRecording')
          var modal = vm.$store.state.modals.modals.find(function (m) {
            return m.designator === 'recording-detected-modal'
          })
          if (modal) vm.$store.commit('modals/removeModalById', modal.modal_id)
        },
        onSnooze: function () {
          dispatch('snoozeRecording', { vm: vm, recording: recording })
        },
        onSubmitForAnalysis: function (params) {
          // Close the detection modal
          commit('clearCurrentRecording')
          var modal = vm.$store.state.modals.modals.find(function (m) {
            return m.designator === 'recording-detected-modal'
          })
          if (modal) vm.$store.commit('modals/removeModalById', modal.modal_id)

          commit('setAnalyzing', true)

          if (params._callType === 'employer') {
            // Employer flow — transcribe only, no review modal
            vm.$utils.emit('show_toast', { text: 'השיחה נשלחה לתמלול...', type: 'info' })

            vm.$network_utils.submitEmployerRecording({
              recording_path: params.recording_path,
              company_id: params.company_id,
              contact_name: params.contact_name
            })
              .then(function () {
                commit('setAnalyzing', false)
                commit('markProcessed', recording.path || recording.filename)
                vm.$utils.emit('show_toast', { text: 'השיחה תומללה ונשמרה בהצלחה', type: 'success' })
              })
              .catch(function (error) {
                commit('setAnalyzing', false)
                var msg = (error && error.response && error.response.data && error.response.data.error) || 'שגיאה בתמלול השיחה'
                vm.$utils.emit('show_toast', { text: msg, type: 'error' })
              })
          } else {
            // Applicant flow
            var isFollowUp = params.mode === 'follow_up'
            vm.$utils.emit('show_toast', {
              text: isFollowUp ? 'השיחה נשלחה לסיכום...' : 'בודק שיחה...',
              type: 'info'
            })

            vm.$network_utils.submitRecordingForAnalysis(params)
              .then(function (response) {
                commit('setAnalyzing', false)
                commit('markProcessed', recording.path || recording.filename)

                // Follow-up mode — summary only, no review needed
                if (isFollowUp) {
                  vm.$utils.emit('show_toast', { text: 'סיכום שיחת הפולואו אפ נשמר בהערות פנימיות', type: 'success' })
                  return
                }

                var items = response.items || []

                if (items.length === 0) {
                  vm.$utils.emit('show_toast', { text: 'לא זוהו פריטים בשיחה — סיכום השיחה נשמר בהערות פנימיות', type: 'info' })
                  return
                }

                // Open review modal with results
                vm.$store.commit('modals/create', {
                  designator: 'recording-review-modal',
                  component_name: 'RecordingDetectedModal',
                  modal_width: 1100,
                  is_center_modal: true,
                  modal_title: 'תוצאות ניתוח שיחה',
                  is_fixed: true,
                  persistent: true,
                  show_close_button: false,
                  props: {
                    recording: recording,
                    startAtReview: true,
                    initialReviewItems: items,
                    initialStatementsCount: response.statements_count,
                    selectedApplicantData: params._applicantData,
                    onComplete: function () {
                      var reviewModal = vm.$store.state.modals.modals.find(function (m) {
                        return m.designator === 'recording-review-modal'
                      })
                      if (reviewModal) vm.$store.commit('modals/removeModalById', reviewModal.modal_id)
                    }
                  }
                })
              })
              .catch(function (error) {
                commit('setAnalyzing', false)
                console.error('[RecordingMonitor] Analysis error:', error)
                var msg = (error && error.response && error.response.data && error.response.data.error) || 'שגיאה בניתוח השיחה'
                vm.$utils.emit('show_toast', { text: msg, type: 'error' })
              })
          }
        }
      }
    })
  },

  snoozeRecording: function (context, payload) {
    var commit = context.commit
    var dispatch = context.dispatch
    var vm = payload.vm
    var recording = payload.recording

    // Close the modal
    commit('clearCurrentRecording')
    var modal = vm.$store.state.modals.modals.find(function (m) {
      return m.designator === 'recording-detected-modal'
    })
    if (modal) vm.$store.commit('modals/removeModalById', modal.modal_id)

    // Store snoozed recording and re-open after 60s
    commit('setSnoozedRecording', recording)
    if (snoozeTimer) clearTimeout(snoozeTimer)
    snoozeTimer = setTimeout(function () {
      commit('clearSnoozedRecording')
      snoozeTimer = null
      dispatch('openRecordingModal', { vm: vm, recording: recording })
    }, 60000)
  },

  stopPolling: function (context) {
    var commit = context.commit
    if (pollingInterval) {
      clearInterval(pollingInterval)
      pollingInterval = null
    }
    if (snoozeTimer) {
      clearTimeout(snoozeTimer)
      snoozeTimer = null
      commit('clearSnoozedRecording')
    }
    commit('setPolling', false)
  }
}

var getters = {
  hasPending: function (state) {
    return state.pendingRecordings.length > 0
  }
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
